// Shared PostHog event for anything with a "share this" action (badge
// modal, creator-post share shelf, individual social buttons) so every
// share surface reports the same event/property shape.
export function trackSharedContent (method) {
  if (typeof window.posthog !== 'undefined') {
    window.posthog.capture('shared_content', {
      share_method: method,
      source: window.location.pathname
    })
  }
}
